<template>
  <section class="lg:max-w-[600px] lg:mx-auto lg:!px-0">
    <StatusBar v-if="!isDesktopFlow" />
    <section :class="{ 'px-4': !isDesktopFlow }">
      <h1 class="text-2xl md:text-4xl font-bold font-heading mb-8">Checkout</h1>
      <CheckoutContactForm ref="contactForm" class="mb-6" />
      <p
        v-if="error.message"
        id="error-display"
        class="p-2 mt-4 rounded border border-red-400 bg-red-200 text-red-600"
      >
        {{ error.message }}
      </p>
    </section>
    <div class="px-4 block lg:hidden">
      <GuestLegalLink />
    </div>
    <CheckoutBottomBar
      :nextButtonText="nextButtonText"
      :isNextButtonDisabled="!contactForm?.isContactFormValid || isSaving"
      @click:next="saveContactInfo"
    />
    <GuestLegalLink class="hidden lg:block" />
  </section>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, ref, useTemplateRef } from 'vue'

import GuestLegalLink from '@/modules/guestUi/components/atoms/GuestLegalLink.vue'
import CheckoutBottomBar from '@/modules/guestUi/components/organisms/CheckoutBottomBar.vue'
import CheckoutContactForm from '@/modules/guestUi/components/organisms/CheckoutContactForm.vue'
import StatusBar from '@/modules/guestUi/components/organisms/StatusBar.vue'
import { useCheckoutStore } from '@/stores/checkout'
import { ErrorData, blankError, clearError, displayHandled } from '@/utils/errors'

const checkoutStore = useCheckoutStore()
const { isDesktopFlow, requiresPayment } = storeToRefs(checkoutStore)

const contactForm = useTemplateRef<InstanceType<typeof CheckoutContactForm>>('contactForm')

const isSaving = ref<boolean>(false)
const error = ref<ErrorData>(blankError())
async function saveContactInfo() {
  if (isSaving.value) return

  isSaving.value = true
  clearError(error.value)
  try {
    await checkoutStore.setContactInfo()
  } catch (e) {
    displayHandled(e, error.value)
  } finally {
    isSaving.value = false
  }
}

const nextButtonText = computed<string>(() => {
  if (!isSaving.value) return requiresPayment.value ? 'Enter Payment' : 'Reserve'
  else return requiresPayment.value ? 'Saving...' : 'Reserving...'
})
</script>
